<template>
  <div class="relative bg-gray-900 flex items-stretch select-none text-white">
    <div class="font-mono ml-3 self-center py-2 flex items-center w-full">
      <div class="flex-grow flex items-center">
        <a href="#" @click.prevent="hideDocumentation" class="flex items-center">
          <img src="https://tinkerwell.app/images/icon.png" class="h-8 pr-4" />
          Tinkerwell
        </a>
      </div>

      <button href="#"
        @click.prevent="saveSnippet"
        :disabled="! canSaveSnippet"
        :class="{
          'bg-blue-500 hover:bg-blue-700': canSaveSnippet,
          'cursor-not-allowed bg-gray-500 hover:bg-gray-700': ! canSaveSnippet,
        }"
        class="mr-2 self-end text-white py-2 px-3 rounded"
      >Save</button>

      <button href="#"
        v-if="hasSnippet"
        @click.prevent="deleteSnippet"
        class="bg-red-500 hover:bg-red-700 mr-2 self-end text-white py-2 px-3 rounded"
      >Delete</button>

      <a href="https://tinkerwell.app/?ref=playground" class="mr-2 self-end bg-blue-500 hover:bg-blue-700 text-white py-2 px-3 rounded">Get the Tinkerwell desktop app</a>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import ApiClient from '../../apiClient';
import Swal from 'sweetalert2';

export default {
  name: 'Navbar',
  computed: {
    canSaveSnippet() {
      return this.$store.state.Code.isDirty === true;
    },
    hasSnippet() {
      return this.$route.params.snippet;
    }
  },
  methods: {

    openSnippet() {

      let code = this.$store.state.Code.code;

      if (this.$store.state.Code.mode !== 'cli') {
        code = this.$store.state.Code.controller;
      }

      document.location.href = 'tinkerwell://?code=' + btoa(code);
    },

    hideDocumentation() {
      this.$store.dispatch("showDocumentation", false);
    },

    async deleteSnippet() {
      const { value: deletePassword, dismiss: reason } = await Swal.fire({
        title: 'Enter the delete password',
        text: 'Please enter the password you chose when creating this snippet.',
        input: 'text',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
        inputValue: this.$store.state.Code.deletePassword,
      })

      if (reason === 'cancel') {
        return;
      }

      await ApiClient.delete(
          this.$route.params.snippet,
          deletePassword
      );

      this.$router.push(`/`);
    },

    async saveSnippet() {
      this.$root.$emit('php.run.tinkerwell');

      const { value: deletePassword } = await Swal.fire({
        title: 'Enter a delete password',
        text: 'Use this password if you want to delete the snippet later on.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        input: 'text',
        inputValue: this.$store.state.Code.deletePassword,
      })

      this.$store.dispatch("setPreference", {
        key: "deletePassword",
        value: deletePassword,
      });

      this.$store.dispatch("setIsDirty", false);

      const hash = await ApiClient.save(
          deletePassword,
          this.$store.state.Code.mode,
          this.$store.state.Code.code,
          this.$store.state.Code.controller,
          this.$store.state.Code.view,
          this.$store.state.Code.output
      );

      if (hash !== null) {
        this.$store.dispatch("setSavedHash", hash);

        this.$router.push(`/snippets/${hash}`);
      }
    }

  }
};
</script>

<style scoped>

</style>
